<template>
  <v-container class="w-100 d-flex justify-center">
    <div class="loader"></div> 
  </v-container>
</template>

<script lang="ts">

import { defineComponent } from 'vue';

export default defineComponent({
  name: "Loader",
  data() {
    return {}
  },
})

</script>

<style>

.loader {
  border: 4px solid #eeeeee;
  border-top: 4px solid #283593;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} 

</style>